// extracted by mini-css-extract-plugin
export var colorSquare = "_nq-0";
export var container = "_nq-h";
export var danger = "_nq-5";
export var lightPink = "_nq-8";
export var neutralBlue = "_nq-7";
export var neutralYellow = "_nq-6";
export var normal = "_nq-1";
export var primary = "_nq-2";
export var primaryLight = "_nq-3";
export var selected = "_nq-i";
export var solidBlack = "_nq-g";
export var solidGreen = "_nq-b";
export var solidLightBlue = "_nq-d";
export var solidNavy = "_nq-c";
export var solidOrange = "_nq-f";
export var solidPink = "_nq-e";
export var solidRed = "_nq-9";
export var solidYellow = "_nq-a";
export var success = "_nq-4";